import React, { Fragment, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import Toolbar from '../components/Toolbar';
import useAuth from '../hooks/UseAuth'
import { sortNotifications } from '../services/sortNotifications';
import CheckInOut from './modals/CheckInOut';
import CreateAbsence from './modals/CreateAbsence';
import UploadFile from './modals/UploadDocument';
import { useTranslation } from 'react-i18next';
import { Button, Modal } from 'react-bootstrap';
import { editNotification, getNotifications } from '../actions/notificationActions';
import { getUser } from '../actions/userActions';


export default function Home() {
    const { t } = useTranslation();
    const {auth} = useAuth()
    const dispatch = useDispatch()

    const {user} = useSelector(state => state.users)
    const {departments} = useSelector(state => state.departments)

    const {notifications} = useSelector(state => state.notifications)
    const [userNotifications, setUserNotifications] = useState([])

    const [week, setWeek] = useState([])

    useEffect(()=>{
        const weekdays = ["Domingo", "Lunes", "Martes", "Miercoles", "Jueves", "Viernes", "Sabado"]
        if(auth?.user){
        dispatch(getUser(auth.user, true))
        dispatch(getNotifications(auth.user))

        let array = []
    
        for (var i = 0; i <= 7; i++) {
            var currentDate = new Date();
            currentDate.setDate(currentDate.getDate() + i)
            array.push({
            day: weekdays[currentDate.getDay()],
            date: currentDate.getDate(),
            month: currentDate.getMonth()
            })
        }
    
        setWeek(array)
        }
    }, [auth, dispatch])

    useEffect(()=>{
        if(notifications){
        setUserNotifications(sortNotifications(notifications))
        }
    }, [notifications])

    const viewNotification = async(id)=>{
        dispatch(editNotification(id))
    }

    return (
        <>
        {/*begin::Toolbar*/}
        <Toolbar title={t('Fichar Entrada/Salida')}>
            <CheckInOut />
        </Toolbar>
        {/*end::Toolbar*/}
        {/*begin::Container*/}
        <div id="kt_content_container" className="d-flex flex-column-fluid align-items-start container-xxl">
            {/*begin::Post*/}
            <div className="content flex-row-fluid" id="kt_content">
            {/*begin::Row*/}
            <div className="row g-5 g-xl-10">
                {/*begin::Col*/}
                <div className="col-xl-4 mb-xl-10">
                {/*begin::Lists Widget 19*/}
                <div className="card card-flush h-xl-100" style={{background: '#1C325E'}}>
                    {/*begin::Heading*/}
                    <div className="card-header rounded bgi-no-repeat bgi-size-cover bgi-position-y-top bgi-position-x-center align-items-start h-250px" style={{backgroundImage: 'url("/assets/media/svg/shapes/top-green.png")'}}>
                    {/*begin::Title*/}
                    <h3 className="card-title align-items-start flex-column text-white pt-15">
                        <span className="fw-bolder fs-2x mb-3">{t('Bienvenido')}, {auth?.username}</span>
                        <div className="fs-4 text-white">
                        <span className="opacity-75">{t('Aquí tienes un menú de acciones rápidas')}</span>
                        </div>
                    </h3>
                    {/*end::Title*/}
                    </div>
                    {/*end::Heading*/}
                    {/*begin::Body*/}
                    <div className="card-body mt-n20">
                    {/*begin::Stats*/}
                    <div className="mt-n20 position-relative">
                        {/*begin::Row*/}
                        <div className="row g-3 g-lg-6">
                        {/*begin::Col*/}
                        <div className="col-6">
                            {/*begin::Items*/}
                            <CreateAbsence />
                            {/*end::Items*/}
                        </div>
                        {/*end::Col*/}
                        {/*begin::Col*/}
                        <div className="col-6">
                            {/*begin::Items*/}
                            <Link to={'/payrolls'} className="d-flex flex-column flex-center h-100 p-6 bg-hover-secondary rounded-2 bg-gray-100 bg-opacity-70  px-6 py-5">
                            {/*begin::Svg Icon | path: icons/duotune/finance/fin009.svg*/}
                            <span className="svg-icon svg-icon-3x svg-icon-primary mb-2">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path opacity="0.3" d="M20 15H4C2.9 15 2 14.1 2 13V7C2 6.4 2.4 6 3 6H21C21.6 6 22 6.4 22 7V13C22 14.1 21.1 15 20 15ZM13 12H11C10.5 12 10 12.4 10 13V16C10 16.5 10.4 17 11 17H13C13.6 17 14 16.6 14 16V13C14 12.4 13.6 12 13 12Z" fill="currentColor"/>
                                <path d="M14 6V5H10V6H8V5C8 3.9 8.9 3 10 3H14C15.1 3 16 3.9 16 5V6H14ZM20 15H14V16C14 16.6 13.5 17 13 17H11C10.5 17 10 16.6 10 16V15H4C3.6 15 3.3 14.9 3 14.7V18C3 19.1 3.9 20 5 20H19C20.1 20 21 19.1 21 18V14.7C20.7 14.9 20.4 15 20 15Z" fill="currentColor"/>
                                </svg>
                            </span>
                            {/*end::Svg Icon*/}
                            <span className="fs-4 fw-bold text-gray-800 mb-0">{t('Nominas')}</span>
                            </Link>
                            {/*end::Items*/}
                        </div>
                        {/*end::Col*/}
                        {/*begin::Col*/}
                        <div className="col-6">
                            {/*begin::Items*/}
                            <UploadFile />
                            {/*end::Items*/}
                        </div>
                        {/*end::Col*/}
                        {/*begin::Col*/}
                        <div className="col-6">
                            {/*begin::Items*/}
                            <Link to={'/schedule'} className="d-flex flex-column flex-center h-100 p-6 bg-hover-secondary rounded-2 bg-gray-100 bg-opacity-70  px-6 py-5">
                            {/*begin::Svg Icon | path: icons/duotune/finance/fin009.svg*/}
                            <span className="svg-icon svg-icon-3x svg-icon-primary mb-2">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path opacity="0.3" d="M21 22H3C2.4 22 2 21.6 2 21V5C2 4.4 2.4 4 3 4H21C21.6 4 22 4.4 22 5V21C22 21.6 21.6 22 21 22Z" fill="currentColor"/>
                                <path d="M6 6C5.4 6 5 5.6 5 5V3C5 2.4 5.4 2 6 2C6.6 2 7 2.4 7 3V5C7 5.6 6.6 6 6 6ZM11 5V3C11 2.4 10.6 2 10 2C9.4 2 9 2.4 9 3V5C9 5.6 9.4 6 10 6C10.6 6 11 5.6 11 5ZM15 5V3C15 2.4 14.6 2 14 2C13.4 2 13 2.4 13 3V5C13 5.6 13.4 6 14 6C14.6 6 15 5.6 15 5ZM19 5V3C19 2.4 18.6 2 18 2C17.4 2 17 2.4 17 3V5C17 5.6 17.4 6 18 6C18.6 6 19 5.6 19 5Z" fill="currentColor"/>
                                <path d="M8.8 13.1C9.2 13.1 9.5 13 9.7 12.8C9.9 12.6 10.1 12.3 10.1 11.9C10.1 11.6 10 11.3 9.8 11.1C9.6 10.9 9.3 10.8 9 10.8C8.8 10.8 8.59999 10.8 8.39999 10.9C8.19999 11 8.1 11.1 8 11.2C7.9 11.3 7.8 11.4 7.7 11.6C7.6 11.8 7.5 11.9 7.5 12.1C7.5 12.2 7.4 12.2 7.3 12.3C7.2 12.4 7.09999 12.4 6.89999 12.4C6.69999 12.4 6.6 12.3 6.5 12.2C6.4 12.1 6.3 11.9 6.3 11.7C6.3 11.5 6.4 11.3 6.5 11.1C6.6 10.9 6.8 10.7 7 10.5C7.2 10.3 7.49999 10.1 7.89999 10C8.29999 9.90003 8.60001 9.80003 9.10001 9.80003C9.50001 9.80003 9.80001 9.90003 10.1 10C10.4 10.1 10.7 10.3 10.9 10.4C11.1 10.5 11.3 10.8 11.4 11.1C11.5 11.4 11.6 11.6 11.6 11.9C11.6 12.3 11.5 12.6 11.3 12.9C11.1 13.2 10.9 13.5 10.6 13.7C10.9 13.9 11.2 14.1 11.4 14.3C11.6 14.5 11.8 14.7 11.9 15C12 15.3 12.1 15.5 12.1 15.8C12.1 16.2 12 16.5 11.9 16.8C11.8 17.1 11.5 17.4 11.3 17.7C11.1 18 10.7 18.2 10.3 18.3C9.9 18.4 9.5 18.5 9 18.5C8.5 18.5 8.1 18.4 7.7 18.2C7.3 18 7 17.8 6.8 17.6C6.6 17.4 6.4 17.1 6.3 16.8C6.2 16.5 6.10001 16.3 6.10001 16.1C6.10001 15.9 6.2 15.7 6.3 15.6C6.4 15.5 6.6 15.4 6.8 15.4C6.9 15.4 7.00001 15.4 7.10001 15.5C7.20001 15.6 7.3 15.6 7.3 15.7C7.5 16.2 7.7 16.6 8 16.9C8.3 17.2 8.6 17.3 9 17.3C9.2 17.3 9.5 17.2 9.7 17.1C9.9 17 10.1 16.8 10.3 16.6C10.5 16.4 10.5 16.1 10.5 15.8C10.5 15.3 10.4 15 10.1 14.7C9.80001 14.4 9.50001 14.3 9.10001 14.3C9.00001 14.3 8.9 14.3 8.7 14.3C8.5 14.3 8.39999 14.3 8.39999 14.3C8.19999 14.3 7.99999 14.2 7.89999 14.1C7.79999 14 7.7 13.8 7.7 13.7C7.7 13.5 7.79999 13.4 7.89999 13.2C7.99999 13 8.2 13 8.5 13H8.8V13.1ZM15.3 17.5V12.2C14.3 13 13.6 13.3 13.3 13.3C13.1 13.3 13 13.2 12.9 13.1C12.8 13 12.7 12.8 12.7 12.6C12.7 12.4 12.8 12.3 12.9 12.2C13 12.1 13.2 12 13.6 11.8C14.1 11.6 14.5 11.3 14.7 11.1C14.9 10.9 15.2 10.6 15.5 10.3C15.8 10 15.9 9.80003 15.9 9.70003C15.9 9.60003 16.1 9.60004 16.3 9.60004C16.5 9.60004 16.7 9.70003 16.8 9.80003C16.9 9.90003 17 10.2 17 10.5V17.2C17 18 16.7 18.4 16.2 18.4C16 18.4 15.8 18.3 15.6 18.2C15.4 18.1 15.3 17.8 15.3 17.5Z" fill="currentColor"/>
                                </svg>
                            </span>
                            {/*end::Svg Icon*/}
                            <span className="fs-4 fw-bold text-gray-800 mb-0">Horario</span>
                            </Link>
                            {/*end::Items*/}
                        </div>
                        {/*end::Col*/}
                        </div>
                        {/*end::Row*/}
                    </div>
                    {/*end::Stats*/}
                    </div>
                    {/*end::Body*/}
                </div>
                {/*end::Lists Widget 19*/}
                </div>
                {/*end::Col*/}
                {/*begin::Col*/}
                <div className="col-xl-8 mb-5 mb-xl-10">
                {/*begin::Row*/}
                <div className="row gy-5 g-xl-8">
                    {/*begin::Col*/}
                    <div className="col-xl-6">
                    {/*begin::Slider Widget 1*/}
                    <div id="kt_sliders_widget_1_slider" className="card card-flush carousel carousel-custom carousel-stretch slide h-xl-100" data-bs-ride="carousel" data-bs-interval={5000}>
                        {/*begin::Header*/}
                        <div className="card-header pt-5">
                        {/*begin::Title*/}
                        <div className="card-title d-flex align-items-start flex-column">
                            <h3 className="card-title fw-bolder text-dark">{t('Departamentos')}</h3>
                            <span className="text-gray-400 mt-1 fw-bolder fs-7">{t('Tus departamentos')}</span>
                        </div>
                        {/*end::Title*/}
                        {/*begin::Toolbar*/}
                        <div className="card-toolbar">
                            {/*begin::Carousel Indicators*/}
                            <ol className="p-0 m-0 carousel-indicators carousel-indicators-bullet carousel-indicators-active-primary">
                            {
                                user?.departments?.map((department, i)=>
                                <li key={i} data-bs-target="#kt_sliders_widget_1_slider" data-bs-slide-to={i} className={i === 0 ? 'active ms-1' : 'ms-1'} />
                                )
                            }
                            </ol>
                            {/*end::Carousel Indicators*/}
                        </div>
                        {/*end::Toolbar*/}
                        </div>
                        {/*end::Header*/}
                        {/*begin::Body*/}
                        <div className="card-body pt-6 scroll-y mh-425px">
                        {/*begin::Carousel*/}
                        <div className="carousel-inner mt-n5">
                        {
                            user?.departments?.map((userDepartment, i)=>
                            <div key={i} className={i === 0 ? 'carousel-item active show' : 'carousel-item'}>
                                {/*begin::Header*/}
                                <div className="border-0 mt-3">
                                <h3 className="card-title fw-bolder text-primary fs-5">{userDepartment.name}</h3>
                                </div>
                                {/*end::Header*/}
                                {/*begin::Body*/}
                                <div className="pt-2">
                                {
                                    departments?.map((department, k) =>
                                        <Fragment key={k}>
                                            {
                                                department.name === userDepartment.name ?
                                                department?.users?.map((departmentUser, j)=>
                                                    <div key={j} className="d-flex align-items-center mb-7">
                                                        {/*begin::Avatar*/}
                                                        <div className="symbol symbol-50px me-5">
                                                            <img src={departmentUser.imageProfile} alt='avatar' />
                                                        </div>
                                                        {/*end::Avatar*/}
                                                        {/*begin::Text*/}
                                                        <div className="flex-grow-1">
                                                            <Link to={`/user/${departmentUser.id}`} href="#" className="text-dark fw-bolder text-hover-primary fs-6">{departmentUser.username}</Link>
                                                            <span className="text-muted d-block fw-bold">{departmentUser.employ}</span>
                                                        </div>
                                                        {/*end::Text*/}
                                                    </div>
                                                )
                                                : ''
                                            }
                                        </Fragment>
                                    )
                                }
                                </div>
                                {/*end::Body*/}
                            </div>
                            )
                        }
                        </div>
                        {/*end::Carousel*/}
                        </div>
                        {/*end::Body*/}
                    </div>
                    {/*end::Slider Widget 1*/}
                    </div>
                    {/*end::Col*/}
                    {/*begin::Col*/}
                    <div className="col-xl-6">
                    {/*begin::List Widget 6*/}
                    <div className="card card-flush h-xl-100">
                        {/*begin::Header*/}
                        <div className="card-header border-0">
                        <h3 className="card-title fw-bolder text-dark mt-5">{t('Notificaciones')}</h3>
                        <div className="card-toolbar">
                            {/*begin::Menu*/}
                            <button type="button" className="btn btn-sm btn-icon btn-color-primary btn-active-light-primary" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end">
                            {/*begin::Svg Icon | path: icons/duotune/general/gen024.svg*/}
                            <span className="svg-icon svg-icon-2">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24">
                                <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
                                    <rect x={5} y={5} width={5} height={5} rx={1} fill="#000000" />
                                    <rect x={14} y={5} width={5} height={5} rx={1} fill="#000000" opacity="0.3" />
                                    <rect x={5} y={14} width={5} height={5} rx={1} fill="#000000" opacity="0.3" />
                                    <rect x={14} y={14} width={5} height={5} rx={1} fill="#000000" opacity="0.3" />
                                </g>
                                </svg>
                            </span>
                            {/*end::Svg Icon*/}
                            </button>
                            {/*end::Menu*/}
                        </div>
                        </div>
                        {/*end::Header*/}
                        {/*begin::Body*/}
                        <div className="card-body pt-0 scroll-y mh-425px">
                        {/*begin::Item*/}
                        {
                            userNotifications?.map((notification, i)=>
                            <Link key={i} to={`/notifications`} className="d-flex flex-stack py-4 bg-hover-light rounded-2">
                                {/*begin::Section*/}
                                <div className="d-flex align-items-center">
                                {/*begin::Symbol*/}
                                <div className="symbol symbol-35px me-4">
                                    <span className="symbol-label bg-light-primary">
                                    {
                                    notification.view 
                                        ? <span className="svg-icon svg-icon-2 svg-icon-primary">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <path d="M6 8.725C6 8.125 6.4 7.725 7 7.725H14L18 11.725V12.925L22 9.725L12.6 2.225C12.2 1.925 11.7 1.925 11.4 2.225L2 9.725L6 12.925V8.725Z" fill="currentColor"/>
                                            <path opacity="0.3" d="M22 9.72498V20.725C22 21.325 21.6 21.725 21 21.725H3C2.4 21.725 2 21.325 2 20.725V9.72498L11.4 17.225C11.8 17.525 12.3 17.525 12.6 17.225L22 9.72498ZM15 11.725H18L14 7.72498V10.725C14 11.325 14.4 11.725 15 11.725Z" fill="currentColor"/>
                                            </svg>
                                        </span>
                                        : <span className="svg-icon svg-icon-2 svg-icon-primary">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <path opacity="0.3" d="M21 19H3C2.4 19 2 18.6 2 18V6C2 5.4 2.4 5 3 5H21C21.6 5 22 5.4 22 6V18C22 18.6 21.6 19 21 19Z" fill="currentColor"/>
                                            <path d="M21 5H2.99999C2.69999 5 2.49999 5.10005 2.29999 5.30005L11.2 13.3C11.7 13.7 12.4 13.7 12.8 13.3L21.7 5.30005C21.5 5.10005 21.3 5 21 5Z" fill="currentColor"/>
                                            </svg>
                                        </span>
                                    }
                                    </span>
                                </div>
                                {/*end::Symbol*/}
                                {/*begin::Title*/}
                                <div className="mb-0 me-2">
                                    <div className="fs-6 text-gray-800 text-hover-primary fw-bolder">{notification.title.length > 20 ? notification.title.substring(0,25)+'...' : notification.title}</div>
                                    <div className="text-gray-400 fs-7">{t('De')}: {notification.sendUser.username}</div>
                                </div>
                                {/*end::Title*/}
                                </div>
                                {/*end::Section*/}
                                {/*begin::Label*/}
                                <span className="badge badge-light fs-8">{notification.dateTimeFormated}</span>
                                {/*end::Label*/}
                            </Link>
                            )
                        }
                        {/*end::Item*/}
                        </div>
                        {/*end::Body*/}
                    </div>
                    {/*end::List Widget 6*/}
                    </div>
                    {/*end::Col*/}
                </div>
                {/*end::Row*/}
                </div>
                {/*end::Col*/}
            </div>
            {/*end::Row*/}
            {/*begin::Row*/}
            {/* <div className="row g-5 g-xl-10">
                <div className="col-xl-4 mb-xl-10">
                <div className="card h-xl-100">
                    <div className="card-header border-0 pt-5">
                    <h3 className="card-title align-items-start flex-column">
                        <span className="card-label fw-bolder text-dark">{t('Tareas')}</span>
                        <span className="text-muted mt-1 fw-bold fs-7">{user?.tasks?.length} {t('tareas pendientes')}</span>
                    </h3>
                    <div className="card-toolbar">
                        <button type="button" className="btn btn-sm btn-icon btn-color-primary btn-active-light-primary" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end">
                        <span className="svg-icon svg-icon-2">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24">
                            <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
                                <rect x={5} y={5} width={5} height={5} rx={1} fill="#000000" />
                                <rect x={14} y={5} width={5} height={5} rx={1} fill="#000000" opacity="0.3" />
                                <rect x={5} y={14} width={5} height={5} rx={1} fill="#000000" opacity="0.3" />
                                <rect x={14} y={14} width={5} height={5} rx={1} fill="#000000" opacity="0.3" />
                            </g>
                            </svg>
                        </span>
                        </button>
                    </div>
                    </div>
                    <div className="card-body pt-5 scroll-y mh-425px">
                    {
                        user?.tasks?.map((task, i) =>
                        <Link to={`/task/${task.id}`} key={i} className="d-flex align-items-center bg-hover-light rounded-2 p-2">
                        <div className="symbol symbol-50px me-5">
                            <span className="symbol-label bg-light-success">
                            <span className="svg-icon svg-icon-2x svg-icon-success">
                                <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none">
                                <path opacity="0.3" d="M21.25 18.525L13.05 21.825C12.35 22.125 11.65 22.125 10.95 21.825L2.75 18.525C1.75 18.125 1.75 16.725 2.75 16.325L4.04999 15.825L10.25 18.325C10.85 18.525 11.45 18.625 12.05 18.625C12.65 18.625 13.25 18.525 13.85 18.325L20.05 15.825L21.35 16.325C22.35 16.725 22.35 18.125 21.25 18.525ZM13.05 16.425L21.25 13.125C22.25 12.725 22.25 11.325 21.25 10.925L13.05 7.62502C12.35 7.32502 11.65 7.32502 10.95 7.62502L2.75 10.925C1.75 11.325 1.75 12.725 2.75 13.125L10.95 16.425C11.65 16.725 12.45 16.725 13.05 16.425Z" fill="black" />
                                <path d="M11.05 11.025L2.84998 7.725C1.84998 7.325 1.84998 5.925 2.84998 5.525L11.05 2.225C11.75 1.925 12.45 1.925 13.15 2.225L21.35 5.525C22.35 5.925 22.35 7.325 21.35 7.725L13.05 11.025C12.45 11.325 11.65 11.325 11.05 11.025Z" fill="black" />
                                </svg>
                            </span>
                            </span>
                        </div>
                        <div className="flex-grow-1">
                            <div className="text-gray-800 text-hover-primary fw-bolder fs-6">{task.name}</div>
                            <span className="text-muted fw-bold d-block">{task.department?.name}</span>
                        </div>
                        {
                            task.status === 'Pendiente' 
                            ? <span className="badge badge-light-info fs-8 fw-bolder">{task.status}</span>
                            : <span className="badge badge-light-success fs-8 fw-bolder">{task.status}</span>
                        }
                        </Link>
                        )
                    }
                    </div>
                </div>
                </div>
                <div className="col-xl-8 mb-5 mb-xl-10">
                <div className="card card-flush mb-6 mb-xl-9">
                    <div className="card-header mt-6">
                        <div className="card-title flex-column">
                        <h2 className="mb-1">{t('Horario')}</h2>
                        <div className="fs-6 fw-bold text-muted">{t('Tu horario semanal')}</div>
                        </div>
                    </div>
                    <div className="card-body p-9 pt-4 scroll-y mh-500px">
                        <ul className="nav nav-pills d-flex flex-nowrap hover-scroll-x py-2">
                        {
                            week?.length
                            ? (
                            week.map((day, i) => 
                            <li key={i} className="nav-item me-1">
                                <a  className={`nav-link btn d-flex flex-column flex-center rounded-pill min-w-40px me-2 py-4 btn-active-primary ${i === 0 ? 'active' : ''}`} data-bs-toggle="tab" href={`#kt_schedule_day_${i}`}>
                                    <span className="opacity-50 fs-7 fw-bold">{t(day.day)}</span>
                                    <span className="fs-6 fw-boldest">{day.date}</span>
                                </a>
                            </li>
                            )
                            )
                            : ''
                        }
                        </ul>
                        <div className="tab-content">
                        {
                            week?.length
                            ? (
                            week.map((week, i) => 
                                <div key={i} id={`kt_schedule_day_${i}`} className={`tab-pane fade show ${i === 0 ? 'active' : ''}`}>
                                {
                                    user?.schedules?.length
                                    ? (
                                    user?.schedules.map((schedule, j) => 
                                        schedule.day === week.day 
                                        ? <div key={j} className="d-flex flex-stack position-relative mt-6">
                                            <div className="position-absolute h-100 w-4px bg-secondary rounded top-0 start-0" />
                                            <div className="fw-bold ms-5">
                                            <div className="fs-7 mb-1">{schedule.checkInTime} - {schedule.checkOutTime}
                                                <span className="fs-7 text-muted text-uppercase"> pm</span></div>
                                            <Link to={`/schedule/${schedule.id}`} className="fs-5 fw-bolder text-dark text-hover-primary mb-2">{schedule.name}</Link>
                                            <div className="fs-7 text-muted">{t('Asignado por')}
                                                <Link to={'#'} > Administrador</Link></div>
                                            </div>
                                        </div>
                                        : <Fragment key={j}></Fragment>
                                    )
                                    ) : <></>
                                }
                                </div>
                            )
                            )
                            : ''
                        }
                        </div>
                    </div>
                </div>
                </div>
            </div> */}
            </div>
            {/*end::Post*/}
        </div>
        {/*end::Container*/}
        {/*start::Notification modal*/}
        {
            userNotifications?.map((notification, i) =>
            notification.view === false && notification.sendUser.username !== auth?.username
            ?
                <Modal show={true} key={i}>
                <Modal.Header className='modal-header py-7 d-flex justify-content-between'>
                    <h2>Nueva notificación</h2>
                </Modal.Header>
                <Modal.Body>
                    <h2>{notification.title}</h2>
                    <div>{notification.description}</div>
                    <hr/>
                    <div className="symbol symbol-50 d-flex align-items-center me-4">
                        <span className="symbol-label" style={{backgroundImage: `url(${notification.sendUser?.imageProfile})`}} />
                        <span className="ms-2">{notification.sendUser?.name}</span>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant='primary' type='button' onClick={() => {viewNotification(notification.id)}}>{t('Aceptar')}</Button>
                </Modal.Footer>
                </Modal>
            :
                <Fragment key={i}></Fragment>
        )}
        {/*end::Notification modal*/}
        </>
    )
}